import { PAYBOX, PROCESS_PAYMENT_RESULT } from "./apiURl";
import { commonHeaders, getRequest } from "./httpHelper";

export const getPayboxDataAPI = async (action) => {
  try {
    const response = await getRequest({
      url: `${PAYBOX}`,
      headers: commonHeaders
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching paybox data:", error);
    return null;
  }
};

export const getPaymentResultAPI = async (action) => {
  const { payload } = action;
  const { paymentResponseMode } = payload;

  let url = null;
  if (paymentResponseMode === "stripe") {
    url = `${PROCESS_PAYMENT_RESULT}?payment_provider=stripe&session_id=${payload.sessionId}`;
  } else if (paymentResponseMode === "paybox") {
    url = `${PROCESS_PAYMENT_RESULT}?invoice=${payload.purchaseOrderNo}&payment_provider=paybox&erreur=${payload.erreur}&trans=${payload.trans}&montant=${payload.montant}&auto=${payload.auto}&paiement=${payload.paiement}&carte=${payload.carte}&abonnement=${payload.abonnement}`;
  } else if (paymentResponseMode === "lemonway") {
    url = `${PROCESS_PAYMENT_RESULT}?invoice=${payload.purchaseOrderNo}&payment_provider=lemonway`;
  }

  try {
    const response = await getRequest({
      url: url,
      headers: commonHeaders
    });

    return response.data;
  } catch (error) {
    console.log("Error fetching payment result:", error);
    return null;
  }
};
